import queryString from 'query-string';
import moment from 'moment';

import { PAGE_START } from '../constants/routes';

export const DATE_FORMAT = 'DD/MM/YYYY';
export const API_DATE_FORMAT = 'YYYY/MM/DD';

const initialState = {
  date: moment().format(DATE_FORMAT),
};

export const stringifyQuery = (values, encode = false) =>
  queryString.stringify(
    { ...initialState, ...values },
    {
      encode,
      arrayFormat: 'comma',
    }
  );

export const parseQuery = (query, options = {}) => ({
  ...initialState,
  ...queryString.parse(query, {
    ...options,
    arrayFormat: 'comma',
  }),
});

export const paramsToArray = (query, fields) => {
  const transform = (value) => (typeof value === 'number' ? [value] : value);

  return {
    ...query,
    ...fields.reduce((acc, field) => {
      if (query[field]) {
        return {
          ...acc,
          [field]: transform(query[field]),
        };
      }

      return acc;
    }, {}),
  };
};

export const getActiveTabIndex = (pathname) =>
  `${pathname}`.includes(PAGE_START) ? 0 : 1;
